import styled from "styled-components";

export const EditorCanvas = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
`;

export const EditorContent = styled.div`
  position: relative;
  width: 100%;
  margin-left: 400px;
  height: calc(${({ isMacroEditor }) => (isMacroEditor ? 90 : 100)}vh - 113px);

  .simplebar-content {
    height: 100%;
  }

  @media (max-width: 1740px) {
    height: calc(100vh - 113px);
  }
`;

export const ConfigContainer = styled.div`
  padding: 0 20px 16px;
  height: 100%;
`;

export const BlanketContainer = styled.div`
  [data-testid="info-blanket"] {
    z-index: 1010;
  }
`;

export const AdvancedButton = styled.div`
  color: ${({ color }) => color};
  font-size: 14px;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  margin-top: 15px;
  gap: 15px;
`;

export const ConfigIconButton = styled.div`
  background: ${({ colors }) => colors.bg};
  border-radius: 3px;
  border: 2px solid ${({ colors }) => colors.border};
  width: 36px;
  height: 36px;
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;

  * {
    margin: 0;
  }
`;

export const ConfigSection = styled.div`
  border-top: 1px solid ${({ divider }) => divider};
  padding: 20px 0 0;
  margin: 20px 0 0;
`;

export const ConfigButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  border-radius: 3px;
  padding: 12px;
  font-size: 14px;
  cursor: pointer;
  background: ${({ bg }) => bg};
  color: ${({ color }) => color};

  &:hover {
    background: ${({ bg }) => bg}dd;
  }
  &:active {
    background: ${({ bg }) => bg}ee;
  }
`;

export const SelectedCardPanel = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;

export const TabsButton = styled.div`
  display: inline-flex;
  cursor: pointer;
  line-height: 1;
  margin: 21px 0 21px;
  padding: 8px 25px;
  background: ${({ bg }) => bg};
  color: ${({ color }) => color};
  border: 1px dashed ${({ color }) => color};
  border-radius: 18px;
  font-size: 14px;

  &:hover {
    background: ${({ color }) => color};
    color: #fff;
  }
`;

export const GlobalRowWidthActions = styled.div`
  position: sticky;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 17px 16px;
  top: 0;
  z-index: 400;
  background: ${({ bg }) => bg};
  border-bottom: 1px ${({ border }) => border} solid;
`;

export const TemplatesButton = styled.div`
  display: flex;
  align-items: center;
  column-gap: 5px;
  color: ${({ color }) => color};
  cursor: pointer;
  margin: 0 6px 0 18px;
  padding-right: 12px;
`;

export const UndoRedoContainer = styled.div`
  display: flex;
  gap: 9px;
  margin: 0 18px 0 108px;
  color: #07145a;

  & > span {
    opacity: 0.3;

    ${({ hasPrev, hasNext }) => `
      &: ${hasPrev ? "first" : "only"}-child,
      &: ${hasNext ? "last" : "only"}-child {
        cursor: pointer;
        opacity: 1;

        &:hover {
          opacity: 0.7;
        }
      }
    `}
  }
`;

export const ViewActions = styled.div`
  display: flex;
  justify-content: center;
  column-gap: 6px;
`;

export const RowWidthIcon = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
`;

export const AddCardButton = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: 4px dashed ${({ color }) => color};
  border-radius: ${({ radius }) => radius}px;
  height: ${({ isCompact }) => (isCompact ? "120px" : "auto")};

  &:after {
    content: "";
    position: absolute;
    inset: -3px;
    background: ${({ bg }) => bg};
    border-radius: ${({ radius }) => radius - 1}px;
  }

  * {
    z-index: 50;
    color: ${({ color }) => color};
  }

  &:hover {
    opacity: 0.8;
  }

  &:only-child {
    min-height: 230px;
  }
`;

export const CardsContainer = styled.div`
  display: grid;
  width: 100%;
  box-sizing: border-box;
  grid-template-columns: repeat(${({ columns }) => columns}, 1fr);
  grid-auto-rows: 1fr;
  padding: ${({ isEditor }) => (isEditor ? "60px 60px 250px" : "16px")};
  gap: ${({ gap }) => gap}px;
`;

// Card Actions

export const ActionsContainer = styled.div`
  position: relative;

  &:hover .card-actions {
    display: flex;
  }

  &:before {
    display: ${({ isSelected }) => (isSelected ? "flex" : "none")};
    content: "";
    position: absolute;
    inset: -3px;
    border: 3px solid #649cff;
    border-radius: ${({ design, borderRadius }) => {
      if (design === "la_paz") return `${borderRadius + 5}px`;
      if (design === "mumbai") return `${borderRadius + 4}px`;

      return `${borderRadius + 2}px`;
    }};
  }
`;

export const ActionsToolbar = styled.div`
  display: none;
  position: absolute;
  align-items: center;
  justify-content: center;
  top: 2px;
  width: 100%;
  z-index: 501;
`;

export const ActionsButton = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  padding: 8px 12px;
  color: ${({ color }) => color};
  background: ${({ bg }) => bg}cc;
  cursor: pointer;

  &:first-child {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    padding-left: 15px;
  }

  &:last-child {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    padding-right: 15px;
  }

  &:hover {
    background: ${({ bg }) => bg};
  }

  &:after {
    position: absolute;
    content: "";
    margin: auto;
    width: 14px;
    height: 14px;
    top: 20px;
    left: 0;
    right: 0;
    z-index: -1;
    transform: rotate(45deg);
    background: #f4f5f8;
    display: ${({ hasAnchor }) => (hasAnchor ? "block" : "none")};
  }
`;
